import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
const CustomDetailBox = styled(Box)(({ theme }) => ({
  pt: 2,
  pb: 0,
  width: "100%",
  overflow: "auto",
  height: `calc(100% - 40px)`,
}));

export default CustomDetailBox;
